import React, { useState, useEffect, useContext } from 'react';
import { AuthContext, ViewContext, Event } from 'components/lib';
import { Box, Stack, Avatar, Typography, Select, MenuItem, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from '@mui/material';
import { 
    SubdirectoryArrowRightOutlined as DSIcon,
    CheckCircleOutlineOutlined as CheckIcon,
    DeleteOutline as DeleteIcon,
    HourglassEmptyOutlined as ProvisioningIcon,
    CheckCircleOutlineOutlined as ReadyIcon,
 } from '@mui/icons-material';
import { indigo, green, yellow, grey } from '@mui/material/colors';

import { Card } from 'mbd-components/card';
import { Text } from 'mbd-components/text';
import { PrimaryButton } from 'mbd-components/primary-button';
import farcasterLogo from 'assets/farcaster_logo.jpg';
import { BrandedDialog } from 'mbd-components/branded-dialog';
import { EditableTextField } from 'views/feed-config/editable_text_field';
import logo_image from '../../assets/logo_image.png';
import { SecondaryButton } from 'mbd-components/secondary-button';
const dataSourceTypeOptions = [
    "items",
    "label"
]

const SelectField = (props) =>
    {
      return (
        <Box sx={{display:'flex', flexDirection: props.horizontal ? 'row' : 'column', alignItems: props.horizontal ? 'center' : 'flex-start'}} fullWidth >
          <Text variant='fieldHeading' color={props.headingColor || 'brand-light'}>
            {props.heading}
          </Text>
          <FormControl variant="outlined" sx={{width: props.width ? props.width : '100%'}}>
            <Select 
              value={props.value} 
              onChange={props.onChange} 
              width='600px'
              sx={{ marginLeft: props.horizontal ? 2 : 0, marginTop: props.horizontal ? 0 : 2}}
            >
              {props.options.map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )
    }

export function DataSources() {

    const [publicDataSources, setPublicDataSources] = useState([]);
    const [privateDataSources, setPrivateDataSources] = useState([]);
    const [newDataSourceDialogOpen, setNewDataSourceDialogOpen] = useState(false);
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [newDataSourceId, setNewDataSourceId] = useState(0);
    const [deleteDataSourceId, setDeleteDataSourceId] = useState(-1);
    const [deleteDataSourceName, setDeleteDataSourceName] = useState('');
    const authContext = useContext(AuthContext);
    const viewContext = useContext(ViewContext);

    const handleCreateDataSource = () => {
        setNewDataSourceDialogOpen(true);
        console.log('create data source');
    }
    const deleteDataSourceWithId = async (id) => {
        setPrivateDataSources(privateDataSources.filter(dataSource => dataSource.id !== id) );
    }

    const handleDataSourceCreated = (id, dataSourceName, dataSourceType) => {
        privateDataSources.push({
            id: id,
            name: dataSourceName,
            type: dataSourceType
        })
    

    }

    const PublicDataSourceBox = ({name, id, icon, description}) => {
        return (
            <Stack my={2} direction="row" alignItems="center" spacing={2} sx={{borderRadius: 2, border: '1px solid #e0e0e0', padding: 2, width: '450px'}}>
                <Avatar src={icon} />
                <Stack>
                    <Typography variant="body1" fontWeight="medium">{name}</Typography>
                    <Text color='gray-light'>We index this data source in real-time by default. </Text>
                </Stack>
            </Stack>
        )
    }

    const PrivateDataSourceBox = ({name, id, type, status}) => {
        return (
            <Stack direction="row" spacing={2} my={2} alignItems="center">
                <Stack my={2} direction="row" alignItems="center" spacing={2} sx={{borderRadius: 2, border: '1px solid #e0e0e0', padding: 2, width: '500px'}}>
                    <Avatar sx={{ bgcolor: indigo[50] }}>
                        <DSIcon color='white' />
                    </Avatar>
                    <Stack width='100%'>
                        <Typography variant="body1" fontWeight="medium">{name}</Typography>
                        <Stack direction="row" spacing={8} justifyContent="space-between" >
                            <Text color='gray-light' sx={{height: 20}}>id: {id}</Text>
                            {/* <Text color='gray-light' sx={{right: 10}}>type: {type}</Text> */}

                        </Stack>

                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center" height={20} sx={{borderRadius: 10, border: '1px solid #e0e0e0', padding: 2}}>
                        {status === 'ready' ? <ReadyIcon sx={{color: '#e0e0e0'}} fontSize='small'/> : <ProvisioningIcon sx={{color: '#e0e0e0'}} fontSize='small'/>}
                        <Text color='gray-light' sx={{right: 10}}>{status}</Text>
                        {/* <Box sx={{width: 12, height: 12, backgroundColor: status === 'ready' ? green[200] : yellow[300], borderRadius: 6}}></Box> */}
                    </Stack>


                </Stack>
                <IconButton onClick={() => {setDeleteDataSourceId(id); setDeleteDataSourceName(name); setDeleteDialogOpen(true)}} sx={{width: 40, height: 40, borderRadius: 20, backgroudColor: '#f0f0f0', marginRight: 1}}>
                    <Tooltip title="Delete Data Source">
                        <DeleteIcon />
                    </Tooltip>
                </IconButton>
            </Stack>
        )
    }

    const NewDataSourceDialog = ( {createdHandler}) => {
        const [dataSourceName, setDataSourceName] = useState('');
        const [dataSourceType, setDataSourceType] = useState(dataSourceTypeOptions[0]);
        // const [dataSourceType, setDataSourceType] = useState(dataSourceTypeOptions[0]);
        return (
            <Dialog open={newDataSourceDialogOpen}>
                <DialogTitle>
                    <Stack px={2} direction={'row'} my={2} alignItems={'center'} justifyContent={'space-between'}>
                    Create Data Source
                    <Avatar src={logo_image} alt="Company Logo" style={{width: 35, height: 35}}/>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <Box mb={2} mx={4}>
                        <EditableTextField horizontal={false} heading="Data Source Name" value={dataSourceName} onChange={(e) => setDataSourceName(e.target.value)}/>
                        <Box mt={2}>
                            <SelectField heading="Data Source Type" value={dataSourceType} onChange={e => setDataSourceType(e.target.value)} options={dataSourceTypeOptions.map(option => ({label: option, value: option}))} />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{justifyContent: 'center', mb: 3}}>
                    <PrimaryButton onClick={() => {
                        setNewDataSourceId(`ds-${privateDataSources.length + 1}`)
                        createdHandler && createdHandler(`ds-${privateDataSources.length + 1}`, dataSourceName, dataSourceType);
                        setNewDataSourceDialogOpen(false)
                        setSuccessDialogOpen(true)
                    }}>Create</PrimaryButton>
                </DialogActions>
            </Dialog>
        )
    }
    
    const SuccessDialog = () => <BrandedDialog 
        open={successDialogOpen} 
        title="Data Source Successfully Created" 
        onClose={() => setSuccessDialogOpen(false)}
        jsx={
        <Box>
            {/* <Box justifyContent={'center'} width={'100%'}>
                <CheckIcon sx={{ color: indigo[300]}} fontSize={100}/>
            </Box> */}
            <Text variant='body1'>
                You can now use the following endpoints to send data to your data source:
            </Text>
            <Stack mt={2}>
                <Text variant='body1'>
                    http://datasources-api.mbd.xyz/data-sources/{newDataSourceId}/items
                </Text>
                <Text variant='body1'>
                    http://datasources-api.mbd.xyz/data-sources/{newDataSourceId}/users
                </Text>
                <Text variant='body1'>
                    http://datasources-api.mbd.xyz/data-sources/{newDataSourceId}/interaction-items
                </Text>
                <Text variant='body1'>
                    http://datasources-api.mbd.xyz/data-sources/{newDataSourceId}/interaction-users
                </Text>
            </Stack>
        </Box>
        }
    />

    const ConfirmDeleteDialog = () => {

        
        return (<BrandedDialog 
            open={deleteDialogOpen} 
            title="Confirm Delete Data Source" 
            onClose={() => setDeleteDialogOpen(false)}
            buttonText="Confirm Delete"
            cancelButtonText="Cancel"
            onConfirm={ () => {deleteDataSourceWithId(deleteDataSourceId)}}
            jsx={
                <Box>
                    <Text variant='body1'>
                        Are you sure you want to delete {`${deleteDataSourceName} (${deleteDataSourceId})`}? All associated data will be deleted, and you will not be able to send data through this data source.
                    </Text>
                </Box>
            }
        />)
    }

    return (
        <>
            <NewDataSourceDialog createdHandler={handleDataSourceCreated}/>
            <SuccessDialog />
            <ConfirmDeleteDialog />
            <Card title="Manage Your Data Sources" description="">
                <Box my={4}>
                    <Text variant='h2'>
                        Public Data Sources
                    </Text>
                    <PublicDataSourceBox name="Farcaster" icon={farcasterLogo} />
                </Box>
                
                <Box my={4}>
                    <Text variant='h2'>
                        Private Data Sources
                    </Text>
                    {
                        privateDataSources.length > 0 ? (
                            privateDataSources.map((dataSource, index) => (
                                <PrivateDataSourceBox key={dataSource.id} name={dataSource.name} id={dataSource.id} type={dataSource.type} status={index === 0 ? 'ready' : 'provisioning'}/>
                            ))
                        )
                        :(
                        <Box my={2}>
                            <Text variant='body2' color='gray-light'>
                                You do not have any private data sources yet.  You can create a data source and send custom private data to mbd to enhance your models.
                            </Text>
                        </Box>)

                    }
                    <PrimaryButton onClick={handleCreateDataSource}>
                        Create Data Source
                    </PrimaryButton>
                </Box>

            </Card>
        </>
    );
}